/**
 * 产康技师可约时段：营业时间、15 分钟格、提前约约束、默认开始时刻（与派单页预约表单一致）
 */
import dayjs from 'dayjs'
import { isValidServiceMinutes, normalizeServiceMinutes } from '@/utils/renderUtils'

/** 营业日可约开始：9:30；结束：18:00（服务结束时刻不得晚于此） */
export const SLOT_START_MINUTES = 9 * 60 + 30
export const BUSINESS_END_MINUTES = 18 * 60
/** 每个可选开始时段的步长（分钟） */
export const SLOT_INTERVAL = 15
/**
 * 时间表展示到的最后一格为 18:00（与营业结束对齐）；
 * 以 18:00 为开始且服务时长>0 时整段会晚于 18:00 结束，由 exceedsBusiness 禁选
 */
export const LAST_SLOT_START_MINUTES = 18 * 60

/**
 * 至少提前多少分钟可预约（仅预约日为「今天」时约束开始时刻；非今日不限制）
 * 与项目服务时长无关
 */
export const BOOKING_LEAD_MINUTES = 30

/** 每行显示时段数（4 = 每小时一行） */
export const SLOTS_PER_ROW = 4

function generateTimeSlots () {
  const slots = []
  for (
    let startMinutes = SLOT_START_MINUTES;
    startMinutes <= LAST_SLOT_START_MINUTES;
    startMinutes += SLOT_INTERVAL
  ) {
    const h = Math.floor(startMinutes / 60)
    const m = startMinutes % 60
    const start = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    const endMinutes = startMinutes + SLOT_INTERVAL
    slots.push({ label: start, value: start, startMinutes, endMinutes })
  }
  return slots
}

export const TIME_SLOTS = generateTimeSlots()

/** 按小时分行，带全局下标（与 TIME_SLOTS 顺序一致） */
export const SLOTS_BY_HOUR = (() => {
  const rows = []
  for (let i = 0; i < TIME_SLOTS.length; i += SLOTS_PER_ROW) {
    rows.push(TIME_SLOTS.slice(i, i + SLOTS_PER_ROW).map((s, j) => ({ ...s, index: i + j })))
  }
  return rows
})()

const toDayjs = (value) => (value ? dayjs(value) : null)

/** 自 0 点起的分钟数 */
const minutesFromMidnight = (d = dayjs()) => d.hour() * 60 + d.minute()

/** 预约日为今天时：已完全过去的时段个数（按「时段结束时刻 ≤ 当前时刻」） */
export function getPastSlotCountForToday (selectedDate) {
  const d = toDayjs(selectedDate)
  if (!d?.isValid() || !d.isSame(dayjs(), 'day')) return -1
  const nowM = minutesFromMidnight()
  const idx = TIME_SLOTS.findIndex((s) => s.endMinutes > nowM)
  return idx === -1 ? TIME_SLOTS.length : idx
}

/**
 * 无已选开始时刻时的默认 HH:mm，与 15 分钟格可约范围一致。
 * 非「今天」为营业首格；为「今天」时取从当前已过的格之后、且该开始 + 整段服务不晚于营业结束的首个格。
 */
export function getDefaultAppointmentStartHm (appointmentDate, serviceTimeMinutes) {
  const d = toDayjs(appointmentDate)
  if (!d?.isValid() || !isValidServiceMinutes(serviceTimeMinutes)) {
    return TIME_SLOTS[0].value
  }
  const sm = normalizeServiceMinutes(serviceTimeMinutes)
  const isToday = d.isSame(dayjs(), 'day')
  const pastCount = isToday ? getPastSlotCountForToday(appointmentDate) : -1
  for (let i = 0; i < TIME_SLOTS.length; i++) {
    if (pastCount >= 0 && i < pastCount) continue
    const s = TIME_SLOTS[i]
    if (s.startMinutes + sm > BUSINESS_END_MINUTES) continue
    return s.value
  }
  return TIME_SLOTS[0].value
}
